import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogedIn } from '../helper';

const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isLogedIn() ?
                <Component {...props} />
            : <Redirect from="/" to="/login" exact/>
        )} />
    );
};

export default PrivateRoute;